import { cleanAmount, groupDigits } from "../amount.ts";
import { money } from "../format.ts";
import { t, type Lang } from "../i18n.ts";
import { hapticSelect } from "../telegram.ts";

export type Currency = "UZS" | "USD";

interface Props {
  value: string;
  onChange: (raw: string) => void;
  currency: Currency;
  /** Если передан — рядом переключатель «сум / $». */
  onCurrency?: (c: Currency) => void;
  lang: Lang;
  quick?: number[];
  autoFocus?: boolean;
  label?: string;
}

/** Крупное поле суммы с цифровой клавиатурой, группировкой разрядов и быстрыми суммами. */
export function AmountField({ value, onChange, currency, onCurrency, lang, quick, autoFocus, label }: Props) {
  const usd = currency === "USD";
  return (
    <div className="field">
      <span>{label ?? t("amount")}</span>
      <div className="amount-field">
        <input
          className="amount-input"
          inputMode={usd ? "decimal" : "numeric"}
          enterKeyHint="done"
          placeholder="0"
          autoFocus={autoFocus}
          value={groupDigits(value)}
          onChange={(e) => onChange(cleanAmount(e.target.value, usd))}
          aria-label={t("amount")}
        />
        {onCurrency ? (
          <div className="currency-switch" role="radiogroup" aria-label={t("currency")}>
            {(["UZS", "USD"] as const).map((c) => (
              <button
                key={c}
                type="button"
                role="radio"
                aria-checked={c === currency}
                className={c === currency ? "cur active" : "cur"}
                onClick={() => {
                  hapticSelect();
                  onCurrency(c);
                  if (c === "UZS") onChange(value.split(".")[0] ?? "");
                }}
              >
                {c === "UZS" ? (lang === "uz" ? "so'm" : "сум") : "$"}
              </button>
            ))}
          </div>
        ) : (
          <span className="amount-unit">{usd ? "$" : lang === "uz" ? "so'm" : "сум"}</span>
        )}
      </div>
      {quick && (
        <div className="chips">
          {quick.map((q) => (
            <button key={q} type="button" className="chip" onClick={() => onChange(String(q))}>
              {money(q, currency, lang)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
